import {CoilSelectionCriteria} from './coil-selection-criteria';

export class UnitSelectionCriteria {

  locationId!: number;
  familyId!: number;
  systemType!: string;
  motorVph!: string;
  motorType!: string;
  filterType!: string;
  modelCode!: string;
  fanSpeedCode!: string;
  pressureDrop!: number;
  maxLength!: number;
  maxHeight!: number;
  maxWidth!: number;
  altitude!: number;
  airflow!: number;
  externalStaticPressure!: number;
  totalStaticPressure!: number;
  metricInput!: boolean;
  coolingCriteria!: CoilSelectionCriteria;
  heatingCriteria!: CoilSelectionCriteria;

}
